import React from 'react';

import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';

import { ReactHookFormInput } from 'common/components/form';

const APIKey = ({ control, disabled }) => {
    const parameters = useWatch({ control, name: 'parameters' });
    const { disabled_credentials } = parameters || {};
    return (
        <ReactHookFormInput
            control={control}
            disabled={disabled || disabled_credentials === true}
            label="API Key"
            name="api_key"
        />
    );
};

APIKey.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
};

export default APIKey;
